<!--
 * @Description: 导入人员预采购任务量
 * @Date: 2023-05-05 14:33:01
-->
<template>
  <div style="padding: 20px">
    <div class="error-alert">
      <p>
        信息校验结果:
        {{ sizeSuccess }}
      </p>
      <p>导入结果: 整批导入失败</p>
      <p>错误内容:</p>
    </div>
    <BaseTable
      style="min-height: 300px"
      ref="baseTableRef"
      :data="(tablePageData as any[])"
      :columns="columns"
      :key="tableData.length"
    ></BaseTable>
    <BasePagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :page-sizes="[15, 60, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length"
      @size-change="handleSizeChange"
      @current-change="handleSizeChange"
    ></BasePagination>
    <BaseButton @click="excelErrorDownload" style="margin: 20px 0">
      下载错误Excel
    </BaseButton>
    <span style="justify-content: center; display: flex; margin: 10px">
      <BaseButton @click="onCancel">取消</BaseButton>
      <BaseButton type="primary" @click="onSubmit">重新提交</BaseButton>
    </span>
  </div>
</template>
<script lang="tsx" setup>
import { ref, computed } from 'vue';
import {
  BaseButton,
  BaseTable,
  BaseTableProps,
  BaseInput,
  useTableColumn,
  XrkMessage,
  createDialog,
  BasePagination,
  XrkMessageBox
} from 'xrk-components';
import { getOriginalExcel, cancelImportExcel } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    done: Function;
    importCount: number;
    failCount: number;
    isGeti: boolean;
    dataList: any[];
    form: {
      excelCode: string;
    };
  }>(),
  {
    done: null,
    isGeti: false,
    form: () => ({
      excelCode: ''
    })
  }
);

const currentPage = ref(1);
const pageSize = ref(15);

const emits = defineEmits(['againSubmit']);

const tableData = ref(props.dataList);
const isCellShow = ref(null);
const sizeSuccess = computed(() => {
  return `导入${props.importCount}条，失败${props.failCount}条`;
});

const excelErrorDownload = () => {
  getOriginalExcel({ excelCode: props.form.excelCode });
};
const tablePageData = ref(
  tableData.value.slice(
    (currentPage.value - 1) * pageSize.value,
    currentPage.value * pageSize.value
  )
);

const handleSizeChange = ({ currentPage, pageSize }) => {
  tablePageData.value = tableData.value.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
};

const columns: BaseTableProps['columns'] = [
  useTableColumn({
    label: '表格位置',
    prop: 'rowNumStr',
    fixed: 'left'
  }),
  props.isGeti &&
    useTableColumn({
      label: '个体工商户名称',
      prop: 'individualName',
      width: '160px',
      render: ({ row }) => {
        return isCellShow.value === 'individualName' + row.rowNum ? (
          <BaseInput
            placeholder="个体工商户名称"
            ref="editInput"
            onInput={e => {
              row.individualName = e;
            }}
            v-model={row.individualName}
            onBlur={() => {
              isCellShow.value = '';
            }}
          ></BaseInput>
        ) : (
          <BaseButton
            onClick={() => {
              isCellShow.value = 'individualName' + row.rowNum;
            }}
            type="text"
          >
            {row.individualName || '-'}
          </BaseButton>
        );
      }
    }),
  useTableColumn({
    label: props.isGeti ? '经营者' : '姓名',
    prop: 'name',
    width: '160px',
    render: ({ row }) => {
      return isCellShow.value === 'name' + row.rowNum ? (
        <BaseInput
          placeholder={'请输入' + props.isGeti ? '经营者' : '姓名'}
          ref="editInput"
          onInput={e => {
            row.name = e;
          }}
          v-model={row.name}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'name' + row.rowNum;
          }}
          type="text"
        >
          {row.name || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '手机号',
    prop: 'phone',
    width: '160px',
    render: ({ row }) => {
      return isCellShow.value === 'phone' + row.rowNum ? (
        <BaseInput
          type="tel"
          ref="editInput"
          placeholder="请输入手机号"
          onInput={e => {
            row.phone = e;
          }}
          v-model={row.phone}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'phone' + row.rowNum;
          }}
          type="text"
        >
          {row.phone || '-'}
        </BaseButton>
      );
    }
  }),
  props.isGeti &&
    useTableColumn({
      label: '园区名称',
      prop: 'businessParkName',
      width: '160px',
      render: ({ row }) => {
        return isCellShow.value === 'businessParkName' + row.rowNum ? (
          <BaseInput
            placeholder="园区名称"
            ref="editInput"
            onInput={e => {
              row.businessParkName = e;
            }}
            v-model={row.businessParkName}
            onBlur={() => {
              isCellShow.value = '';
            }}
          ></BaseInput>
        ) : (
          <BaseButton
            onClick={() => {
              isCellShow.value = 'businessParkName' + row.rowNum;
            }}
            type="text"
          >
            {row.businessParkName || '-'}
          </BaseButton>
        );
      }
    }),
  useTableColumn({
    label: '预采购任务量',
    prop: 'procurementTaskQuantity',
    render: ({ row }) => {
      const inputRule = num => {
        let errMsg = '';
        if (+num > 1000000) {
          errMsg = '输入数字不可大于1000000';
          row.procurementTaskQuantity = 1000000;
        }
        if (+num <= 0) {
          errMsg = '请输入正整数';
          row.procurementTaskQuantity = 1;
        }
        if (errMsg) {
          createDialog({
            width: '300px',
            title: '提示',
            showClose: true,
            showFooter: false,
            content: errMsg
          });
          return;
        }
        row.procurementTaskQuantity = num;
      };
      return isCellShow.value === 'procurementTaskQuantity' + row.rowNum ? (
        <BaseInput
          ref="editInput"
          type="tel"
          maxlength={7}
          placeholder="请输入预采购任务量"
          onInput={e => {
            inputRule(e);
          }}
          v-model={row.procurementTaskQuantity}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'procurementTaskQuantity' + row.rowNum;
          }}
          type="text"
        >
          {row.procurementTaskQuantity ?? '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '人员标签',
    prop: 'userTag',
    width: '160px',
    render: ({ row }) => {
      return isCellShow.value === 'userTag' + row.rowNum ? (
        <BaseInput
          maxlength={10}
          ref="editInput"
          placeholder="请输人员标签"
          onInput={e => {
            row.userTag = e;
          }}
          v-model={row.userTag}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'userTag' + row.rowNum;
          }}
          type="text"
        >
          {row.userTag || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '错误提示',
    width: '300px',
    render: ({ row }) => {
      return row.errorMsgList.map((item, index) => {
        return <p>{`${index + 1}.${item.errorMsg}`}</p>;
      });
    }
  }),
  useTableColumn({
    label: '操作',
    fixed: 'right',
    render: ({ index }) => {
      return (
        <BaseButton
          onClick={() => {
            XrkMessageBox.confirm('此操作将删除该项, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              tableData.value.splice(index, 1);
              tablePageData.value = tableData.value.slice(
                (currentPage.value - 1) * pageSize.value,
                currentPage.value * pageSize.value
              );
              XrkMessage({
                type: 'success',
                message: '删除成功!'
              });
            });
          }}
          type="text"
        >
          删除
        </BaseButton>
      );
    }
  })
].filter(Boolean);

async function onSubmit() {
  await XrkMessageBox.confirm('是否确认重新提交？');
  emits('againSubmit', {
    dataList: tableData.value
  });
  props.done();
}
const onCancel = async () => {
  await cancelImportExcel({ excelCode: props.form.excelCode });
  props.done();
};
</script>
<style lang="scss" scoped>
.error-alert {
  p {
    margin-bottom: 10px;
    color: red;
  }
}
</style>
